(function () {
    'use strict';
    angular
        .module('ipmApp')
        .constant('REGEX_PATTERN', {
        	EMAIL: /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/
        });
})();
